//code added by dmwwebartisan
//start code
// code for custom progress bar
const drawergiftThreshold1 = document.querySelector('cart-element#cart-drawer.cart-drawer.cv-h');
  const drawergiftThreshold2 = document.querySelector('cart-element#cart-drawer.cart-drawer.cv-h');

  const cartgiftThreshold1 = document.querySelector('.cart__message__progress[data-cart-message-progress]');
  const cartgiftThreshold2 = document.querySelector('.cart__message__progress[data-cart-message-progress]');


  const totallimits = document.querySelector(".cart-message--drawer");
  const totallimit = document.querySelector(".cart__message");  
  const freeshipping = document.querySelector('.threshold1').innerText;
  const shippinggift = document.querySelector('.threshold2').innerText;
  const shippingdiscount = document.querySelector('.threshold3').innerText;
  
  const shipping_progress_message = document.querySelector('.free_shipping_progress').innerText;
  const shipping_gift_progress = document.querySelector('.shipping_gift_progress').innerText;
  const shipping_discount_progress = document.querySelector('.shipping_discount_progress').innerText;

  const threshold1 = freeshipping; 
  const threshold2 = shippinggift;
  const threshold3 = shippingdiscount;
  const thresholdDiff = threshold2 - threshold1;
  const thresholdDiff2 = threshold3 - threshold2;


  function waitForElem(waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
    let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
    if (timer <= 0) return;
    ((!isVariable && elements.length >= minElements) || (isVariable && (typeof window[waitFor] !== 'undefined'))) ?
      callback(elements) :
      setTimeout(() => waitForElem(waitFor, callback, minElements, isVariable, (timer - frequency)), frequency);
  };
  const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();
  const changeOnProgressbar = () => {
    const currencySymbol = getCurrencySymbol(navigator.language, Shopify.currency.active);
    waitForElem('.cart__total, .cart__total__money[data-cart-total-price]', () => {
      function updateSubtotal(subtotal){
        const titleWhenUncomplete = "Juhu! Fast geschafft!";
        const titleWhenComplete = "Juhu! Geschafft!";
        const subtitleWhenShipping = shipping_progress_message;
        const subtitleWhenGift = shipping_gift_progress;
        const subtitleWhenGift2 = shipping_discount_progress;
        const subtitleWhenComplete = "Du erhältst ein ÜBERRASCHUNGSGESCHENK 🥳";
        const subtitleWhenComplete1 = "Dein Versand ist gratis. 🥳";
        const subtitleWhenComplete2 = "Du erhältst GRATIS GESCHENKE 🥳";
        var isCompleted = false;
        var subtitleApplied = '';
        
        if (drawergiftThreshold2 || cartgiftThreshold2) {
          if (subtotal >= threshold1 && subtotal < threshold2) {
            //console.log('case 1')
            isCompleted = subtotal >= threshold2;  
            var remaining = threshold2 - subtotal;
            subtitleApplied = subtitleWhenComplete;
            if (!isCompleted) {
              subtitleApplied = subtotal >= threshold1 ? subtitleWhenGift : subtitleWhenShipping;
            }

            subtitleApplied = subtitleApplied.replace("price", (remaining.toFixed(2).replace(".", ",") + ` ${currencySymbol}`));
            
            
          } else if (subtotal >= threshold2 && subtotal < threshold3) {
            //console.log('case 2')
            isCompleted = subtotal >= threshold3;
            var remaining = threshold3 - subtotal;
            subtitleApplied = subtitleWhenComplete2;
            if (!isCompleted) {
              subtitleApplied = subtotal >= threshold2 ? subtitleWhenGift2 : subtitleWhenGift;
            }
            subtitleApplied = subtitleApplied.replace("price", (remaining.toFixed(2).replace(".", ",") + ` ${currencySymbol}`));
          } else {
            //console.log('case 3' + 'subtotal '+subtotal +' threshold1 '+ threshold1);
            isCompleted = subtotal >= threshold1;
            var remaining = threshold1 - subtotal;
            subtitleApplied = subtitleWhenComplete;
            if (!isCompleted) {
              subtitleApplied = subtotal >= threshold1 ? subtitleWhenGift : subtitleWhenShipping;
            }
            subtitleApplied = subtitleApplied.replace("price", (remaining.toFixed(2).replace(".", ",") + ` ${currencySymbol}`));
            document.querySelector(".custom-free-shipping-text [data-title]").textContent = isCompleted ? subtitleWhenComplete1 : subtitleApplied;
          }
          //console.log(isCompleted);
          //document.querySelector(".custom-free-shipping-text [data-title]").textContent = isCompleted ? titleWhenComplete : titleWhenUncomplete;
         // document.querySelector(".custom-free-shipping-text [data-title]").textContent = isCompleted ? subtitleWhenComplete2 : subtitleApplied;
          
        } else {
          var remaining = subtotal >= threshold1 ? threshold2 - subtotal : threshold1 - subtotal;
          isCompleted = subtotal >= threshold2;
          subtitleApplied = subtitleWhenComplete;
          if (!isCompleted) {
            subtitleApplied = subtotal >= threshold1 ? subtitleWhenGift : subtitleWhenShipping;
          }
          subtitleApplied = subtitleApplied.replace("price", (remaining.toFixed(2).replace(".", ",") + ` ${currencySymbol}`));
          //console.log(isCompleted);
          document.querySelector(".custom-free-shipping-text [data-title]").textContent = isCompleted ? titleWhenComplete : titleWhenUncomplete;
          document.querySelector(".custom-free-shipping-text [data-title]").textContent = isCompleted ? subtitleWhenComplete : subtitleApplied;
        }
      }

      function updateShipping(subtotal = 0) {
        subtotal = subtotal > threshold1 ? threshold1 : subtotal;
        const percentageDone = subtotal / threshold1 * 100;
        if (threshold1 === "" ) {
           
         } else if  (percentageDone == 100 && threshold1 !== "" ) {
          //console.log('case-1');
          document.querySelector(".cart__message__progress__holder.icon-free-blank").style.display = 'none';
          document.querySelector(".cart__message__progress__holder.icon-free-color").style.display = 'block';
        } else {
           // console.log('case-2');
          document.querySelector(".cart__message__progress__holder.icon-free-color").style.display = 'none';
          document.querySelector(".cart__message__progress__holder.icon-free-blank").style.display = 'block';
       }
        const shippingElem = document.querySelector(".cart__message__progress__holder .cart__message__progress");
        if (!shippingElem) return;
        shippingElem.style.setProperty("--completed-width", percentageDone.toFixed(2) + "%");  
      }

      function updateGift(subtotal = 0) {
        subtotal = subtotal - threshold1;
        subtotal = subtotal < 0 ? 0 : subtotal;
        subtotal = subtotal > thresholdDiff ? thresholdDiff : subtotal;
        const percentageDone = subtotal / thresholdDiff * 100;
         if (threshold2 === "" ) {
           
         } else if  (percentageDone == 100 && threshold2 !== "" ) {
              document.querySelector(".cart__message__progress__holder.icon-free-gift-blank").style.display = 'none';
              document.querySelector(".cart__message__progress__holder.icon-free-gift-color").style.display = 'block';
            } else {
              document.querySelector(".cart__message__progress__holder.icon-free-gift-color").style.display = 'none';
              document.querySelector(".cart__message__progress__holder.icon-free-gift-blank").style.display = 'block';
       }
        
        const giftElem = document.querySelector(".cart__message__progress__holder .cart__message__progress.freegift");
        if (!giftElem) return;
        giftElem.style.setProperty("--completed-width", percentageDone.toFixed(2) + "%");
      }

      function updateGift2(subtotal = 0) {
        subtotal = subtotal - threshold2;
        subtotal = subtotal < 0 ? 0 : subtotal;
        subtotal = subtotal > thresholdDiff2 ? thresholdDiff2 : subtotal;
        const percentageDone = subtotal / thresholdDiff2 * 100;
        const giftElem2 = document.querySelector(".cart__message__progress__holder .cart__message__progress.freediscount");
        if (!giftElem2) return;
        giftElem2.style.setProperty("--completed-width", percentageDone.toFixed(2) + "%");
      }
      
      const getText = document.querySelector('.cart__total__money[data-cart-total-price]').textContent.trim();
      const subTotalAmount = parseFloat(getText.replace(',', '.').replace(currencySymbol, ''));
     //console.log(subTotalAmount);
      
      updateSubtotal(subTotalAmount);
      updateShipping(subTotalAmount);
      updateGift(subTotalAmount);
      updateGift2(subTotalAmount);

    }, 2);
  }
    changeOnProgressbar();

  waitForElem('.cart__total__money[data-cart-total-price]', () => {
    const changedPrice = document.querySelector('.cart__total__money[data-cart-total-price]');
    const observer = new MutationObserver(changeOnProgressbar);
    observer.observe(changedPrice, { attributes: true, childList: true, subtree: true });
  });



  //code added by dmwwebartisan
  //end code


//code added by dmwwebartisan
//start code
/* code for show gift message */
/**
     * Display Free Gift Message 
     *
	 * Params int quantity
	 *
     * @return  {Void}
     */

  function displayGiftMessage(quantity){
  const cartdrawergiftmessage = document.querySelectorAll('cart-element#cart-drawer.cart-drawer.cv-h');
  const cartpagemessage = document.querySelector('cart-element#cart_message');
  const cartitemcount = quantity;
   if (cartdrawergiftmessage || cartpagemessage) {
        if (cartitemcount == 0 ){
           $(".empty").show();$(".one").hide();$(".two").hide();$(".three").hide();$(".four").hide();
         } else if (cartitemcount == 1){
           $(".empty").hide();$(".one").show();$(".two").hide();$(".three").hide();$(".four").hide();
         } else if (cartitemcount == 2) {
           $(".empty").hide();$(".one").hide();$(".two").show();$(".three").hide();$(".four").hide();
          } else if (cartitemcount == 3) {
          $(".empty").hide();$(".one").hide();$(".two").hide();$(".three").show();$(".four").hide();
          } else if (cartitemcount >= 4) {
          $(".empty").hide();$(".one").hide();$(".two").hide();$(".three").hide();$(".four").show();
         }  else {  
       
         }
	}
    }

//code added by dmwwebartisan
//end code